var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({attrs:{"id":"IngredientsDish"}},'div',_vm.loading(),false),[_c('div',{staticClass:"collection",staticStyle:{"margin-top":"0px !important"},domProps:{"innerHTML":_vm._s(_vm.Obj.ingredientes)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eb1656a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dish/IngredientsDish.vue
// module id = null
// module chunks = 